module.exports = __webpack_public_path__ + "media/images/responsive/articles/icon_header_favorite-b46bc259f65965cddab8314ae5d6d852.svg";